import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { SectionTemplate } from '../../components';
import mask from '../../images/blob-shape.svg';
import { media } from '../../utils/mixins';

export const OperationalEfficiency = () => {
    const { dinning } = useStaticQuery(query);
    return (
        <SectionTemplate
            headingText="Operational"
            subHeadingText="Efficiency"
            paragraphText="Easily track orders and customize pick up times with an
            easy and efficient system. CheaprEats rpovides a
            customizable sales terminal system that works to provide
            clear, simple communication between customers and
            vendors. With this, vendors are able to efficiently
            manage the speed and demand for orders."
            imageContent={<Image fluid={dinning.childImageSharp.fluid} />}
        />
    );
};

const query = graphql`
    {
        dinning: file(relativePath: { eq: "dinning.jpg" }) {
            childImageSharp {
                fluid(maxWidth: 800, quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`;

const Image = styled(Img)`
    mask: url(${mask});
    mask-size: cover;
    max-width: 26rem;
    max-height: 26rem;
    width: 100%;
    height: auto;
    ${media.tablet`
        max-width: 20rem;
        max-height: 20rem;
    `}
`;
